export const MARK_ANNOUNCEMENT_AS_READ = 'MARK_ANNOUNCEMENT_AS_READ';
export const UPDATE_ANNOUNCEMENTS_LIST = 'UPDATE_ANNOUNCEMENTS_LIST';
